module.exports = "/assets/data/2ac53f941482690c763bd2ee931c03d0-AL6.data.json";